import { all, fork } from 'redux-saga/effects';

import allBanksReducer from './bankAll/reducer';
import allBanksSaga from './bankAll/saga';
import bankCardsReducer from './bankCards/reducer';
import bankCardsSaga from './bankCards/saga';

export const paymentReducers = {
  allBanks: allBanksReducer,
  bankCards: bankCardsReducer,
};

export function* paymentSagas() {
  yield all(
    [allBanksSaga, bankCardsSaga].map(function (saga) {
      return fork(saga);
    }),
  );
}
